import React, { Component } from 'react';

import { Button, Tabs, Modal, Icon, Input, message,LocaleProvider,Table ,Divider} from 'antd';
const { Search } = Input;
import Crumbs from './../../../Crumbs/Crumbs';//面包屑
import zh_CN from 'antd/lib/locale-provider/zh_CN';

import { connect } from "react-redux"//联系store的组件
import evn from "./../../../../../actions/index"//action的所有事件
import EventSet from "./../../../../../assets/PubJs/hcPub"//公用的所有事件
import { Hcurl } from "./../../../../../constants/index"//获取公共路径
import $ from "jquery"
import CompanyFristLogin from './../CompanyFristLogin/CompanyFristLogin';
import createHistory from 'history/createHashHistory';//路由切换地址
import CompanyModal from "./../CompanyModal/index"//组件携带参数“0”或者“1”，0为有切换用户，1无切换用户
import ChangeCompanyModal from "./../CompanyModal/changeCom"


import "./../style.css"
import { setTimeout } from 'core-js/library/web/timers';

const TabPane = Tabs.TabPane;
const history = createHistory();//定义history路由


//解除绑定
let _DelBind = null;
let time1 = null
class DelBind extends React.Component {
    state = {
        Text: '获取验证码',
        disable: false,
        visible: false,
        confirmLoading: false,
        phone: EventSet.getUserInfo().linkPhone,
        yzm: "",
        record:'',
        codeTrue:false
    }

    //弹出modal
    showModal = (e) => {
        console.log('41',e)
        this.setState({
            visible: true,
            record:e,
            Text: '获取验证码',
            disable: false,
            yzm: "",
        });
        clearInterval(time1);
    }
    getCom_Name = () => {  //获取先行和解默认企业信息
        console.log('解除绑定')
        $.ajax({
            url: Hcurl + "/CompanyCore/GetXXHJCompanyDefultName?u_code=" + EventSet.getUserInfo().CU_Code,
            type: 'post',
            success: function (data) {
                console.log(data, 'success');
                if (data == '' || data == null) {
                    let userInfo = JSON.parse(localStorage.userInfo);
                    userInfo.xxhjcompanycode = null;
                    userInfo.XXHJCom_Name = null;
                    localStorage.setItem("userInfo", JSON.stringify(userInfo));
                } else {
                    let userInfo = JSON.parse(localStorage.userInfo);
                    userInfo.xxhjcompanycode = data.split("|")[1];
                    userInfo.XXHJCom_Name = data.split("|")[2];
                    localStorage.setItem("userInfo", JSON.stringify(userInfo));
                }
                setTimeout(() => {
                    window.location.reload()
                }, 300);
                //history.push({
                //    pathname: "/Content/Business/CompanyList/test",
                //})
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                console.log(data, 'error')
            }

        })
    }

    //发送短信及验证
    handleOk = () => {
        this.setState({
            confirmLoading: true,
        });
        let _this = this;
        if (_this.state.yzm == "") {
            message.error("请输入验证码")
            _this.setState({
                confirmLoading: false,
            });
            return
        }
        let setData = {
            UserCode: EventSet.getUserInfo().CU_Code,
            CompanyCode: _DelBind.state.record.Com_Code,
            UnBindType:'6',
            ValidCode:_this.state.yzm
        };
        $.ajax({
            url: Hcurl + "/CompanyCore/Unbind",
            type: "post",
            data: setData,
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {

                console.log(res.split("|"));
                if (res.split("|")[0] === "true") {
                    _DelBind.getCom_Name();
                    message.success("提交成功")
                    if (res.split("|")[1] === "") {
                        let userInfo = JSON.parse(localStorage.userInfo);
                        userInfo.UCR_ComID = null;
                        userInfo.Com_Name = null;
                        userInfo.UCR_IsAdmin = null;
                        localStorage.setItem("userInfo", JSON.stringify(userInfo))
                        history.push({
                            pathname: "/Content/Business/CompanyList/test",
                        })
                        _App.props.dispatch(evn.changeTagKey("1"))
                        _DelBind.setState({
                            visible: false,
                            confirmLoading: false,
                        });
                    } else {
                        let userInfo = JSON.parse(localStorage.userInfo);
                        userInfo.UCR_ComID = res.split("|")[1];
                        userInfo.Com_Name = res.split("|")[2];
                        userInfo.UCR_IsAdmin = res.split("|")[3];
                        localStorage.setItem("userInfo", JSON.stringify(userInfo))

                        history.push({
                            pathname: "/Content/Business/CompanyList/test",
                        })
                        _DelBind.setState({
                            visible: false,
                            confirmLoading: false,
                        });
                    }
                }else{
                    message.error(res.split("|")[1])
                    _DelBind.setState({
                        confirmLoading: false,
                    });
                }

            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
        // $.ajax({
        //     url:'https://webservice.jshcsoft.com/SSMSAPI/verifycode.ashx',
        //     type:"post",
	    //     async:false,
        //     data:{
        //         tele:_this.state.phone,//手机号
        //         type:'jiangsu',//来源识别号，一般是项目名称，建议英文
		//         code:_this.state.yzm,//用户输入的验证码
        //     },
        //     success:function(res){
        //         console.log(res);
        //         if (res !='true') {
        //             message.error("验证码错误")
        //             _this.setState({
        //                 confirmLoading: false,
        //             });
        //         } else {
                    
        //         }
              
        //     }
        // })
       
    }

    //点击取消
    handleCancel = () => {
        this.setState({
            visible: false,
        });
    }

    //倒计时
    djs() {
        let _this = this;
        let num = 60;
        num--
        _this.setState({
            Text: num + "s",
            disable: true
        });
        time1 = setInterval(function () {
            num--
            _this.setState({
                Text: num + "s",
            }, () => {
                if (num === 0) {
                    _this.setState({
                        Text: '获取验证码',
                        disable: false
                    });
                    clearInterval(time1);
                }
            });
        }, 1000)
    }

   
       
    
    //fas验证码
    getYzm() {
        let _this = this;
        this.djs()
        $.ajax({
            url: Hcurl + "/HomePage/SendComPhoneValidCode",
            type: "POST",
            headers: {
                token: JSON.parse(localStorage.getItem("userInfo")).token
            },
            data: {
                Type: '6',
                UserCode:JSON.parse(localStorage.getItem("userInfo")).CU_Code,
            },
            async: false,
            success: function (res) {
                if (res.indexOf("true") >= 0) {
                    message.success('验证码发送成功');
                } else {
                    _this.setState({
                        Text: '获取验证码',
                        disable: false
                    });
                    clearInterval(time1);
                    message.error("验证码发送失败");
                }
            }
        })

    }

    //验证码输入改变
    onChangeyzm = (e) => {
        this.setState({ yzm: e.target.value });
    };

    //组件完成
    componentDidMount() {
        _DelBind = this;
    }
    render() {
        const { visible, confirmLoading, ModalText } = this.state;
        return (
            <div>

                <Modal title="解除绑定"
                    visible={visible}
                    onOk={this.handleOk}
                    confirmLoading={confirmLoading}
                    onCancel={this.handleCancel}
                    okText={"确定"}
                    cancelText={"取消"}
                >
                    <p style={{ marginTop: 34, width: 375, margin: "34px auto 0" }}>
                        解绑企业：{this.state.record.Com_Name}
                    </p>
                    <p style={{ textAlign: "center", marginTop: 12, }}>
                        <Input
                            prefix={<Icon type="tablet" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.state.phone}
                            disabled
                            style={{ width: 375 }}
                        />
                    </p>
                    <p style={{ textAlign: "center", marginTop: 34 }}>
                        <Input placeholder="请输入验证码" onChange={this.onChangeyzm} value={this.state.yzm} style={{ width: 280, marginRight: 8 }} />
                        <Button disabled={this.state.disable} style={{ width: 100 }} onClick={this.getYzm.bind(this)}>{this.state.Text}</Button>
                    </p>
                    <p style={{ color: "red", marginTop: 34, width: 375, margin: "34px auto 0" }}>
                        注：验证成功后解除与当前企业的绑定，如当前用户为管理员，则管理员权限自动移交至剩余绑定用户中最早绑定该企业的。
                    </p>
                </Modal>
            </div>
        );
    }
}

let _App
class App extends Component {
    state = {
        hei: 500,
        isAdmin: "block",
        data: [],
        pagination: {
            current: 1,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            total: 0
        },
        sorters: null,
        loading: false,
        pagetotalCount: 0,
        visible: false,
        keyWordVal:'',
    };

    //预设尺寸
    windowChangeSize() {
        let H = window.innerHeight - 229;
        this.setState({
            hei: H
        })
    }

    showModal() {
        this.props.dispatch(evn.showModal())
    }
    showModalChange() {
        this.props.dispatch({ type: "showModalCom" })
    }
    //解除绑定
    relieveBind=(e)=> {
        _DelBind.showModal(e)
    }

    componentDidMount() {
        _App = this;
        this.windowChangeSize()
        EventSet.NavShow(this, "/Content/Business/CompanyList", "Business")//显示菜单
        _App.fench()
    }
    //分页、排序等改变事件
    handleTableChange = (pagination, filters, sorter) => {
        let _this = this;
        this.setState({
            pagination: pagination,
            sorters: sorter
        }, () => {
            _App.fench()
        });
    };

    //表格的渲染
    fench = () => {
        let _this = this
        this.setState({ loading: true });
        const pagination = { ...this.state.pagination };

        let setData = {
            pageSize: pagination.pageSize,
            pageNo: pagination.current,
            keyWord: _App.state.keyWordVal,
            userCode: EventSet.getUserInfo().CU_Code,
        };
        $.ajax({
            url: Hcurl + "/CompanyCore/GetOwnCompanyList",
            type: "post",
            data: setData,
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                let data = JSON.parse(res)
                console.log(data)
                pagination.total = Number(data.TotalCount);
                _this.setState({
                    loading: false,
                    data: data.Rows,
                    pagination: pagination,
                    pagetotalCount: data.TotalCount
                })
                _this.getAllPage()
            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
    };

    //获取当前表格共多少页
    getAllPage() {
        let _this = this
        setTimeout(function () {
            let count = _this.state.pagination.total
            let size = _this.state.pagination.pageSize
            if (count % size !== 0) {
                let num = count - count % size
                _this.setState({
                    allPage: num / size + 1
                })
            } else {
                _this.setState({
                    allPage: count / size
                })
            }
        }, 20)
    }
    showModal() {
        this.props.dispatch(evn.showModal())
    }
    toSetting=(e)=>{
        localStorage.setItem('companyInfo',JSON.stringify(e))
        localStorage.setItem('tabValue','1')
        let userInfo = JSON.parse(localStorage.userInfo);
        userInfo.UCR_IsAdmin =e.UCR_IsAdmin;
        localStorage.setItem("userInfo", JSON.stringify(userInfo))
        history.push({
            pathname: "/Content/Business/CompanyList/MainCenter",
        })
    }
    changeSearch=(e)=>{
        console.log(e)
        this.setState({
            keyWordVal:e
        })
        setTimeout(() => {
            _App.fench()
        }, 200);
        
    }
    render() {
        const columns = [{
            title: '统一社会信用代码',
            dataIndex: 'Com_CreditCode',
            width:250,
        }, {
            title: '主体名称',
            dataIndex: 'Com_Name',
            ellipsis:true,
        }, {
            title: '主体别称',
            dataIndex: 'Com_SimpleName',
            width:120,
            render: (text, record) => {
                if(record.Com_SimpleName!=''&&record.Com_SimpleName!=null){
                    return (
                        <span>{record.Com_SimpleName.replace(/;/g, "；")}</span>
                    )
                }else{
                    return (<span>-</span>)
                    
                }
                
            },
        }, {
            title: '我的角色',
            dataIndex: 'UCR_IsAdmin',
            width:100,
            render: (text, record) => {
                return (
                    record.UCR_IsAdmin=='1'?'管理员':'普通用户'
                )
            },
        }, {
            title: '绑定/加入时间',
            dataIndex: 'BindTime',
            width:180,
        }, {
                title: '操作',
                width:150,
            render: (text, record) => {
                return (
                    <span>
                   {record.UCR_IsAdmin=='1'?<a onClick={()=>this.toSetting(record)}>设置</a>:''} 
                   {record.UCR_IsAdmin=='1'? <Divider type="vertical" />:''}
                    <a onClick={()=>this.relieveBind(record)}>解除绑定</a>
                </span> 
                )
            },
        }];
        return (
            <div id="BusinessCenter">
                <Crumbs title={"主体管理"} />
                <CompanyModal type={"0"} />
                <ChangeCompanyModal />
                <DelBind />
               <div className="BusinessWrap" style={{ minHeight: this.state.hei }}>
                 
                    <div className={"BusinessTab"} style={{padding:'24px'}}>
                    <div style={{height:'40px',}}>
                        <div style={{float:'left',fontSize:'16px',color:'#333',fontWeight:'bold'}}>我的企业/组织/团体</div>
                        <Button onClick={this.showModal.bind(this)} style={{float:'right'}} type="primary">绑定/加入企业</Button>
                        <Search style={{float:'right',width:'300px',marginRight:'12px'}} placeholder="关键字搜索" onSearch={value => this.changeSearch(value)} enterButton />
                        

                    </div>
                    <div style={{ position: "relative", margin: "20px 0" }}>
                            <LocaleProvider locale={zh_CN}>
                                <Table
                                    rowKey={record => record.ID}
                                    pagination={this.state.pagination}
                                    loading={this.state.loading}
                                    onChange={this.handleTableChange}
                                    size="middle"
                                    bordered
                                    columns={columns}
                                    dataSource={this.state.data}
                                    scroll={{ x: 1100 }}
                                />
                            </LocaleProvider>
                        <div style={{ position: "absolute", bottom: "20px", left: "0px" }}>
                            共 {this.state.pagetotalCount}条记录，第{this.state.pagination.current}/{this.state.allPage}页
                        </div>
                    </div>
                    </div>
                </div>
            </div>

        );
    }
}
const mapStateToProps = (state) => {
    return {
        keys: state.TagKey,
    }
};

export default connect(mapStateToProps)(App)


// WEBPACK FOOTER //
// ./src/components/Content/Business/CompanyCenter/CompanyList/CompanyList.js